import React from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {Dropdown1} from '../../../../../_metronic/partials'
import SmppCard from './Smpp'

const More = () => {
  return (
    <>
      <SmppCard />
      <div className={`card mb-6`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-3 mb-1'>Managed Support Tickets</span>
            <span className='text-muted mt-1 fw-bold fs-7'>8 tickets</span>
          </h3>
          <div className='card-toolbar'>
            {/* begin::Menu */}
            <button
              type='button'
              className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTSVG path='media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
            </button>
            <Dropdown1 />
            {/* end::Menu */}
          </div>
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body py-3'>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table align-middle gs-0 gy-5'>
              {/* begin::Table head */}
              <thead>
                <tr>
                  <th className='p-0 min-w-150px'>ISSUE</th>
                  <th className='p-0 min-w-150px'>STATUS</th>
                  <th className='p-0 min-w-150px'>DATE</th>

                  <th className='p-0 min-w-40px'></th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                <tr>
                  <td>
                    <div className='symbol symbol-50px me-2'>
                      <span className='symbol-label'>
                        <img
                          src={toAbsoluteUrl('/media/svg/brand-logos/plurk.svg')}
                          className='h-50 align-self-center'
                          alt=''
                        />
                      </span>
                    </div>
                  </td>
                  <td>
                    <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                      Top Authors
                    </span>
                    <span className='text-muted fw-bold d-block fs-7'>Successful Fellas</span>
                  </td>
                  <td className=''>
                    <span className='badge badge-light-danger fw-bold me-1'>Angular</span>
                  </td>

                  <td className='text-end'>
                    <span className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'>
                      <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-2' />
                    </span>
                  </td>
                </tr>
              </tbody>
              {/* end::Table body */}
            </table>
            {/* end::Table */}
          </div>
          {/* end::Table container */}
        </div>
        {/* end::Body */}
      </div>
      <div className={`card mb-6`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-3 mb-1'>Login Sessions</span>
            <span className='text-muted mt-1 fw-bold fs-7'>8 tickets</span>
          </h3>
          {/* <button>signout all sessions</button> */}
          <div className='d-flex my-4'>
            <span className='btn btn-light-primary btn-sm me-2' id='kt_user_follow_button'>
              <span className='svg-icon svg-icon-3 d-none'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width={24}
                  height={24}
                  viewBox='0 0 24 24'
                  fill='none'
                >
                  <path
                    opacity='0.3'
                    d='M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z'
                    fill='currentColor'
                  />
                  <path
                    d='M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z'
                    fill='currentColor'
                  />
                </svg>
              </span>
              <span className='indicator-label'>signout all sessions</span>

              <span className='indicator-progress'>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2' />
              </span>
            </span>
          </div>
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body py-3'>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table align-middle gs-0 gy-5'>
              {/* begin::Table head */}
              <thead>
                <tr>
                  <th className='p-0 min-w-150px'>LOCATION</th>
                  <th className='p-0 min-w-150px'>DEVICE</th>
                  <th className='p-0 min-w-150px'>IP ADDRESS</th>

                  <th className='p-0 min-w-150px'>DATE & TIME</th>
                  <th className='p-0 min-w-150px'>SESSION DURATION</th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                <tr>
                  <td>
                    <div className='symbol symbol-50px me-2'>
                      <span className='symbol-label'>
                        <img
                          src={toAbsoluteUrl('/media/svg/brand-logos/plurk.svg')}
                          className='h-50 align-self-center'
                          alt=''
                        />
                      </span>
                    </div>
                  </td>
                  <td>
                    <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                      Top Authors
                    </span>
                    <span className='text-muted fw-bold d-block fs-7'>Successful Fellas</span>
                  </td>
                  <td>
                    <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                      Top Authors
                    </span>
                    <span className='text-muted fw-bold d-block fs-7'>Successful Fellas</span>
                  </td>
                  <td>
                    <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                      Top Authors
                    </span>
                    <span className='text-muted fw-bold d-block fs-7'>Successful Fellas</span>
                  </td>
                  <td className=''>
                    <span className='badge badge-light-danger fw-bold me-1'>Angular</span>
                  </td>
                </tr>
              </tbody>
              {/* end::Table body */}
            </table>
            {/* end::Table */}
          </div>
          {/* end::Table container */}
        </div>
        {/* end::Body */}
      </div>
      <div className={`card mb-6`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-3 mb-1'>Login Sessions</span>
            <span className='text-muted mt-1 fw-bold fs-7'>8 tickets</span>
          </h3>
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body py-3'>
          {/* begin::Table container */}
          <div>
            <label className='fw-bold mb-2'>dedicated port </label>
            <div className='row mb-4'>
              <input className=' form-control form-control-solid  mw-500px ms-3' />
              <button className='btn btn-primary ms-2 col-3'>Save Change</button>
            </div>
          </div>
          <div>
            <label className='fw-bold mb-2'>dedicated port </label>
            <div className='row mb-4'>
              <input className=' form-control form-control-solid  mw-500px ms-3' />
              <button className='btn btn-primary ms-2 col-3'>Save Change</button>
            </div>
          </div>
          {/* end::Table container */}
        </div>
        {/* end::Body */}
      </div>
    </>
  )
}

export default More
